<template>
    <div>
        <div class="container-fluid video-how-wave-top mt-5" v-if="course && course.tip_1"></div>
        <div class="container-fluid video-how-bg py-5"
             v-if="course && course.tip_1">
            <div class="container">
                <div class="row">
                    <div class="col-12 video-how-header">
                        {{ $t('how_study_pass') }}
                        <img src="@/assets/poliglotiki/images/how-video-bird.png" class="video-how-bird d-lg-block d-none">
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid video-how-bg" v-if="course && course.tip_1">
            <div class="container">
                <div class="row video-how-items pb-5" >
                    <div class="col-12 video-how-item video-how-item-first d-flex flex-row" v-if="course && course.tip_1">
                        <div class="video-how-point video-how-point-first">1</div>
                        <div class="video-how-text">
                            <vue-markdown-lite>{{ course.tip_1 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 video-how-item d-flex flex-row" v-if="course && course.tip_2">
                        <div class="video-how-point">2</div>
                        <div class="video-how-text">
                            <vue-markdown-lite>{{ course.tip_2 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 video-how-item d-flex flex-row" v-if="course && course.tip_3">
                        <div class="video-how-point">3</div>
                        <div class="video-how-text">
                            <vue-markdown-lite>{{ course.tip_3 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 video-how-item d-flex flex-row" v-if="course && course.tip_4">
                        <div class="video-how-point">4</div>
                        <div class="video-how-text">
                            <vue-markdown-lite>{{ course.tip_4 }}</vue-markdown-lite>
                        </div>
                    </div>

                    <div class="col-12 video-how-item d-flex flex-row" v-if="course && course.tip_5">
                        <div class="video-how-point">5</div>
                        <div class="video-how-text">
                            <vue-markdown-lite>{{ course.tip_5 }}</vue-markdown-lite>
                        </div>
                    </div>
                    <div class="col-12 video-how-item video-how-item-last d-flex flex-row" v-if="course && course.tip_6">
                        <div class="video-how-point video-how-point-last">6</div>
                        <div class="video-how-text">
                            <vue-markdown-lite>{{ course.tip_6 }}</vue-markdown-lite>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid video-how-wave-bottom" v-if="course && course.tip_1"></div>
    </div>
</template>

<script>
    import VueMarkdownLite from '@earthtone/vue-markdown-lite'

    export default {
        name: 'CourseHowVideo',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        components: {
            VueMarkdownLite
        },

        data() {
            return {}
        },

        mounted() {
        },

    }
</script>
<style>
    .video-how-text, .video-how-text p {
        font-size: 18px;
        line-height: 24px;
        color: #4f4d5c;
    }
    .video-how-text strong {
        color: #231c37;
        font-family: "Manrope Bold";
    }

</style>
<style scoped>

    .video-how-header {
        position: relative;
    }

    .video-how-bird {
        position: absolute;
        right: 0;
        top: -35px;
    }

    .video-how-item {
        background-repeat: repeat-y;
        background-image: url('~@/assets/poliglotiki/images/how-video-dash.gif');
        background-position: 41px 4px;
    }

    .video-how-item.video-how-item-last {
        background-image: none;
    }

    .video-how-text {
        margin-left: 40px;
        flex: 1;
        margin-bottom: 30px;
        padding-top: 15px;
    }

    .video-how-point {
        color: #5ab947;
        border: 2px solid #5ab947;
        border-radius: 50%;
        height: 54px;
        width: 54px;
        text-align: center;
        font-size: 24px;
        line-height: 52px;
        font-weight: bold;
        flex: 0 0 54px;
        background: #f2f6f8;
    }

    .video-how-wave-top {
        background-image: url('~@/assets/poliglotiki/images/steps-blue-wave-top.png');
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
        height: 17px;
    }

    .video-how-wave-bottom {
        background-image: url('~@/assets/poliglotiki/images/steps-blue-wave-bottom.png');
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
        height: 22px;
    }

    .video-how-header {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #231c37;
        text-align: center;
    }

    .video-how-bg {
        background-color: #f2f6f8;
        background-position: center;
        background-repeat: no-repeat;
    }



    @media (min-width: 992px) {

    }

    @media (max-width: 991.8px) {
        .video-how-wave-top, .video-how-wave-bottom {
            background-size: cover;
        }
        .video-how-items {
            padding-left: 20px;
            padding-right: 20px;
        }
    }

    @media (min-width: 1920.1px) {
        .video-how-wave-top {
            background-size: 100% 17px;
        }

        .video-how-wave-bottom {
            background-size: 100% 22px;
        }
    }
</style>
